import React, { forwardRef, useId } from "react";
import * as RadixCheckbox from "@radix-ui/react-checkbox";
import { Check, Minus } from "lucide-react";
import "./Checkbox.css";

export const Checkbox = forwardRef(function Checkbox(
  { label, hint, id: idProp, className = "", ...props },
  ref
) {
  const reactId = useId();
  const id = idProp || reactId;
  return (
    <label htmlFor={id} className={`ui-checkbox-row ${className}`}>
      <RadixCheckbox.Root ref={ref} id={id} className="ui-checkbox" {...props}>
        <RadixCheckbox.Indicator className="ui-checkbox-indicator">
          {props.checked === "indeterminate" ? <Minus size={12} /> : <Check size={12} />}
        </RadixCheckbox.Indicator>
      </RadixCheckbox.Root>
      {(label || hint) && (
        <span className="ui-checkbox-text">
          {label && <span className="ui-checkbox-label">{label}</span>}
          {hint && <span className="ui-checkbox-hint">{hint}</span>}
        </span>
      )}
    </label>
  );
});
